module.exports = __webpack_public_path__ + "img/labSquire-logo.f08fda57.svg";